import DepartmentMasterList from "../../../../components/topNavigationComp/masters/roleMaster/Department/RoleMasterlist"
function DepartmentMasterPage() {
    return (
        <>
            <DepartmentMasterList />
        </>
    )
}
export default DepartmentMasterPage